<template>
  <section class="register-content">
    <div class="main">
      <div class="first">
        <h3>{{registerUser_}}</h3>
        <div class="register_form" @input="clearWarning">
          <div class="username">
            {{username_}}*
            <br/>
            <input type="text" value="" v-model="username" @keypress.enter="submit"/>
          </div>
          <div class="password">
            {{password_}}*<br/>
            <input type="password" value="" v-model="password" @keypress.enter="submit"/>
          </div>
          <div class="password_again">
            {{retypePwd_}}*<br/>
            <input type="password" value="" v-model="password_again" @keypress.enter="submit"/>
          </div>
          <div class="Email">
            {{email_}}*<br/>
            <input type="text" value="" v-model="email" @keypress.enter="submit"/>
          </div>
          <div class="buttons">
            <div class="error">{{msg}}</div>
            <a href="javascript:void(0)" class="btn btn-large" @click="submit">{{submit_}}</a>
            <a href="javascript:void(0)" class="btn btn-large" @click="reset">{{reset_}}</a>
          </div>
          <router-link class="login_link" to="/login">{{clickToLogin_}}</router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import { hash } from '@/utils'
  import { register } from '@/utils/api.js'
  import i18n from '@/i18n'

  export default {
    data () {
      return {
        msg: '',
        username: '',
        password: '',
        password_again: '',
        email: ''
      }
    },
    computed: {
      ...mapState(['v_locale']),
      ...mapGetters(['gameOver']),
      ...i18n.map([
        'registerUser_', 'username_', 'password_',
        'retypePwd_', 'email_', 'submit_', 'reset_',
        'clickToLogin_', 'fillAll_', 'invalidUsername_',
        'notMatch_', 'invalidEmail_'
      ])
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      clearWarning () {
        this.msg = ''
      },
      submit () {
        if (!(this.username && this.password && this.password_again && this.email)) {
          this.msg = this.fillAll_
          return
        }
        if (!this.username.match(/[_a-zA-Z][-_a-zA-Z0-9.]{0,63}$/)) {
          this.msg = this.invalidUsername_
          return
        }
        if (this.password !== this.password_again) {
          this.msg = this.notMatch_
          return
        }
        if (!this.email.match(/^[^@]+@[^@]+\.[^@]+$/)) {
          this.msg = this.invalidEmail_
          return
        }

        const pass = hash(this.username, this.password)
        register(this.username, pass, this.email)
          .then(() => {
            this.$router.push('/profile')
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      reset () {
        this.username = ''
        this.password = ''
        this.password_again = ''
        this.email = ''
      }
    },
    created () {
      if (this.gameOver) return this.$router.replace('/rank')
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/register.vue